import React from 'react';
import { Spinner } from 'react-bootstrap';
import '../assets/LoadingComponent.css';

const LoadingComponent = () => {
  return (
    <div className="loading-overlay">
      <div className="spinner-box">
        <Spinner animation="border" variant="light" />
      </div>
    </div>
  );
};

export default LoadingComponent;
